import { GameMainTransitionLandscapeProperties } from "../landscape/GameMainTransitionLandscapeProperties";
export class GameMainTransitionPortraitProperties extends GameMainTransitionLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.transitionSpine.position.set(512, 973);
    }
}
